import img1 from '../assets/images/empoweringdoctor-2.jpg';
import img2 from '../assets/images/empoweringdoctors-1.jpg';
import doctorAvatar from '../assets/images/docter-profile.png';
import profileImg from '../assets/images/articalsdetails-profile.png';

export const liveSessions = [
  {
    id: 1,
    slug: 'advanced-cardiac-life-support-2024',
    title: 'Advanced Cardiac Life Support – 2024',
    thumbnail: img1,
    duration: '20Min',
    date: '20/12/2025',
    time: '02:30 AM',
    authorAvatar: doctorAvatar,
    authorName: 'By Doctor Malik',
    authorRole: 'Senior Cardiologist, Apollo Hospitals',
    hasPlay: true,
    isLive: true,
    viewers: '2.5K',
    description:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae. Integer feugiat, nulla eu blandit hendrerit, turpis elit pellentesque urna, in tincidunt purus sapien non lacus. Curabitur nec lacus sed nunc sollicitudin aliquet. Suspendisse potenti. Sed vulputate, nisi nec bibendum feugiat, ligula nulla facilisis nunc, ut sollicitudin...',
    comments: [
      {
        id: 1,
        author: 'Ralph Edwards',
        avatar: profileImg,
        date: 'Aug 19, 2021',
        text: 'In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. Fringilla pharetra vel massa enim sollicitudin cras. At pulvinar eget sodis adipiscing eget donec ultrices nibh tristique.',
        likes: 0,
        replies: [],
      },
      {
        id: 2,
        author: 'Ralph Edwards',
        avatar: profileImg,
        date: 'Aug 19, 2021',
        text: 'In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. Fringilla pharetra vel massa enim sollicitudin cras. At pulvinar eget sodis adipiscing eget donec ultrices nibh tristique.',
        likes: 0,
        replies: [],
      },
      {
        id: 3,
        author: 'Ralph Edwards',
        avatar: profileImg,
        date: 'Aug 19, 2021',
        text: 'In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. Fringilla pharetra vel massa enim sollicitudin cras. At pulvinar eget sodis adipiscing eget donec ultrices nibh tristique.',
        likes: 0,
        replies: [],
      },
      {
        id: 4,
        author: 'Ralph Edwards',
        avatar: profileImg,
        date: 'Aug 19, 2021',
        text: 'In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. Fringilla pharetra vel massa enim sollicitudin cras. At pulvinar eget sodis adipiscing eget donec ultrices nibh tristique.',
        likes: 0,
        replies: [],
      },
      {
        id: 5,
        author: 'Ralph Edwards',
        avatar: profileImg,
        date: 'Aug 19, 2021',
        text: 'In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. Fringilla pharetra vel massa enim sollicitudin cras. At pulvinar eget sodis adipiscing eget donec ultrices nibh tristique.',
        likes: 0,
        replies: [],
      },
      {
        id: 6,
        author: 'Ralph Edwards',
        avatar: profileImg,
        date: 'Aug 19, 2021',
        text: 'In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. Fringilla pharetra vel massa enim sollicitudin cras. At pulvinar eget sodis adipiscing eget donec ultrices nibh tristique.',
        likes: 0,
        replies: [],
      },
    ],
  },
  {
    id: 2,
    slug: 'neurology-update-workshop-2024',
    title: 'Neurology Update Workshop – 2024',
    thumbnail: img2,
    duration: '35Min',
    date: '15/01/2025',
    time: '03:00 PM',
    authorAvatar: doctorAvatar,
    authorName: 'By Doctor Malik',
    authorRole: 'Senior Cardiologist, Apollo Hospitals',
    hasPlay: true,
    isLive: false,
    viewers: '1.8K',
    description:
      'Our expert doctors will be going live soon to answer your questions and share valuable health insights. Stay tuned for the next session.',
    comments: [],
  },
  {
    id: 3,
    slug: 'diabetes-management-masterclass',
    title: 'Diabetes Management Masterclass',
    thumbnail: img1,
    duration: '45Min',
    date: '22/02/2025',
    time: '10:00 AM',
    authorAvatar: doctorAvatar,
    authorName: 'By Doctor Malik',
    authorRole: 'Senior Cardiologist, Apollo Hospitals',
    hasPlay: true,
    isLive: false,
    viewers: '3.1K',
    description:
      'Our expert doctors will be going live soon to answer your questions and share valuable health insights. Stay tuned for the next session.',
    comments: [],
  },
  {
    id: 4,
    slug: 'pediatric-care-essentials-2025',
    title: 'Pediatric Care Essentials – 2025',
    thumbnail: img2,
    duration: '30Min',
    date: '10/03/2025',
    time: '11:30 AM',
    authorAvatar: doctorAvatar,
    authorName: 'By Doctor Malik',
    authorRole: 'Senior Cardiologist, Apollo Hospitals',
    hasPlay: true,
    isLive: false,
    viewers: '2.2K',
    description:
      'Our expert doctors will be going live soon to answer your questions and share valuable health insights. Stay tuned for the next session.',
    comments: [],
  },
];
